import { buttonVariants } from "~/components/ui/button";
import { useTranslations } from "~/hooks/useTranslations";
import { cn } from "~/lib/utils";

type SaleNotStartedProps = {
  remainingTime: string | null;
  className?: string;
  backgroundColor?: string;
};

export function SaleNotStarted({
  className,
  remainingTime,
  backgroundColor,
}: SaleNotStartedProps) {
  const t = useTranslations();

  return (
    <div
      className={cn(
        buttonVariants({ variant: "default" }),
        "w-full cursor-default",
        className,
      )}
      style={{ backgroundColor }}
    >
      {t.presale + " in "} <span className="text-pear">{remainingTime}</span>
    </div>
  );
}
